import React, { useEffect } from 'react';
import { Loader } from '../loader';
import Footer from '../footer/Footer';
import { CardChat } from '../card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { setChatId, resetChatId } from '../chat-page/chatSlice';
import { useSelector, useDispatch } from 'react-redux';
import uuid from 'react-native-uuid';

const ChatPage = (props) => {
	const dispatch = useDispatch();
	const chatId = useSelector((state) => state.chat.chatId);

	useEffect(() => {
		console.log("Chat has been mounted");
		dispatch(setChatId(uuid.v4()));
	}, [dispatch])

	return (
		<div className="app-page">
			<div className="title-page">
				<Container>
					<Row>
						<Col xs={2}>
							<img src="./333-logo.png" alt="Logo" />
						</Col>
						<Col xs={8}>
							<h2 align="center">333 AI Chatbot</h2>
						</Col>
						<Col xs={2}>
							
						</Col>

					</Row>
				</Container>

			</div>

			<CardChat />
			<Loader />
			<Footer />
		</div>
	);
}

export default ChatPage;